<template>
  <v-container style="max-width: 100%">
    <v-data-table
      :headers="headersContacts"
      :items="contactsWithMeta"
      sort="name"
      :items-per-page="-1"
      disable-pagination
      hide-default-footer
      :search="searchContacts"
    >
      <template v-slot:top>
        <v-toolbar
          flat
        >
          <v-card
            flat
            style="width: 100%"
          >
            <v-card
              flat
              class="d-flex flex-row flex-wrap"
            >
              <v-toolbar-title>Contacts</v-toolbar-title>
              <v-spacer />
              <v-card
                flat
                style="width: 300px"
              >
                <v-text-field
                  v-model="searchContacts"
                  append-icon="$vuetify.icons.icon_mdi_magnify"
                  :label="'Search ' + `${ contactsWithMeta.length }` + ' contact(s)'"
                  single-line
                  hide-details
                  clearable
                />
              </v-card>
              <v-spacer />
              <v-tooltip left>
                <template v-slot:activator="{ on }">
                  <v-btn
                    color="ppc_pink"
                    dark
                    small
                    absolute
                    right
                    fab
                    @click="newContact()"
                    v-on="on"
                  >
                    <v-icon>$vuetify.icons.icon_mdi_plus</v-icon>
                  </v-btn>
                </template>
                <span>new contact</span>
              </v-tooltip>
            </v-card>
          </v-card>
        </v-toolbar>
      </template>
      <template v-slot:[`item.obsolete`]="{ item }">
        <v-icon
          v-if="item.obsolete !== null"
          small
          color="ppc_pink"
        >
          $vuetify.icons.icon_mdi_cancel
        </v-icon>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-icon
          small
          class="mr-2"
          @click="editItem(item)"
        >
          $vuetify.icons.icon_mdi_pencil
        </v-icon>
        <v-icon
          small
          @click="deleteItem(item)"
        >
          $vuetify.icons.icon_mdi_delete
        </v-icon>
      </template>
    </v-data-table>

    <v-dialog
      v-model="dialogEditContact"
      max-width="700px"
      persistent
    >
      <v-form ref="dialogForm">
        <v-card>
          <v-card-title class="ppc_darkgreen darken-1">
            <span class="headline white--text"> {{ formTitle }} {{ editedItem.name }} </span>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col
                cols="12"
                md="8"
              >
                <v-text-field
                  v-model.trim="editedItem.name"
                  label="Name"
                  prepend-icon="$vuetify.icons.icon_mdi_smart_card ppc_darkgreen--text"
                  counter="45"
                  clearable
                  :rules="inputRulesName"
                />
              </v-col>
              <v-col
                cols="12"
                md="8"
              >
                <v-text-field
                  v-model.trim="editedItem.surname"
                  label="Surname"
                  prepend-icon="$vuetify.icons.icon_mdi_smart_card ppc_darkgreen--text"
                  counter="45"
                  clearable
                  :rules="inputRulesName"
                />
              </v-col>
              <v-col
                cols="12"
              >
                <v-text-field
                  v-model.trim="editedItem.address"
                  label="address"
                  prepend-icon="$vuetify.icons.icon_mdi_map_marker"
                  clearable
                  counter="100"
                />
              </v-col>
              <v-col
                cols="auto"
                sm="6"
              >
                <v-select
                  v-model="editedItem.country_id"
                  :items="$store.state.itemsNationality"
                  item-text="nationality"
                  item-value="id"
                  :menu-props="{ auto: true }"
                  label="Select country"
                  single-line
                  prepend-icon="mdi-earth ppc_darkgreen--text"
                  validate-on-blur
                  clearable
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
              >
                <v-text-field
                  v-model.trim="editedItem.phone"
                  label="phone"
                  prepend-icon="mdi-cellphone ppc_darkgreen--text"
                  :rules="inputRulesPhone"
                  clearable
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
              >
                <v-text-field
                  v-model.trim="editedItem.phone_alt"
                  label="alt phone"
                  :rules="inputRulesPhone"
                  clearable
                  prepend-icon="mdi-phone ppc_darkgreen--text"
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
              >
                <v-text-field
                  v-model.trim="editedItem.email"
                  prepend-icon="mdi-email ppc_darkgreen--text"
                  label="email"
                  clearable
                  :rules="inputRulesEmail"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="12"
                class="d-flex flex-row flex-wrap py-0 my-0"
              >
                <v-textarea
                  v-model="editedItem.comments"
                  class="rounded-xl ma-3"
                  auto-grow
                  clearable
                  counter="255"
                  outlined
                  label="Comments (255 max)"
                  :rules="[v => (v || '' ).length <= 255 || 'Comments must be 255 characters or less']"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col
                cols="12"
                class="d-flex flex-row flex-wrap py-0 my-0"
              >
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      color="ppc_pink"
                      fab
                      dark
                      x-small
                      bottom
                      class="mb-3"
                      @click="dialogSelectOrganisations = true"
                      v-on="on"
                    >
                      <v-icon color="white">
                        mdi-plus
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>add organisation</span>
                </v-tooltip>
                <v-card
                  flat
                  class="d-flex flex-column"
                >
                  <v-data-table
                    :headers="headersConnectedOrganisations"
                    :items="connectedOrganisations"
                    class="ma-4"
                    disable-pagination
                    hide-default-footer
                    dense
                  >
                    <template v-slot:[`item.actions`]="{ item }">
                      <v-icon
                        small
                        @click="deleteConnectedOrganisation(item)"
                      >
                        $vuetify.icons.icon_mdi_delete
                      </v-icon>
                    </template>
                    <template v-slot:[`item.country_id`]="{ item }">
                      {{ nationalityById.get(item.country_id) || '—' }}
                    </template>
                  </v-data-table>
                  <v-divider />
                </v-card>
              </v-col>

              <v-col
                cols="12"
                class="d-flex flex-row flex-wrap py-0 my-0"
              >
                <v-col 
                  cols="12"
                  sm="6"
                  md="4"
                  class="py-0 my-0"
                >
                  <v-checkbox
                    :input-value="editedItem.obsolete !== null"
                    label="Obsolete"
                    @change="setObsolete($event)"
                  />
                </v-col>
                <v-col 
                  cols="12"
                  sm="6"
                  md="4"
                  class="py-0 my-0"
                >
                  <v-text-field
                    v-if="editedItem.obsolete !== null"
                    :value="formattedDate(editedItem.obsolete)"
                    disabled
                    label="From"
                    class="ml-2"
                  />
                </v-col>
              </v-col>
            </v-row>
          </v-card-text>

          <v-card-actions>
            <v-spacer />
            <v-btn
              color="ppc_darkgreen darken-1"
              text
              @click="closeDialogEditContact"
            >
              Cancel
            </v-btn>
            <v-btn
              color="ppc_darkgreen darken-1"
              text
              @click="saveContact"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <v-dialog
      v-model="dialogDelete"
      max-width="500px"
    >
      <v-card>
        <v-card-title>Are you sure you want to delete {{ editedItem.name }}?</v-card-title>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="ppc_darkgreen darken-1"
            text
            @click="closeDelete"
          >
            Cancel
          </v-btn>
          <v-btn
            color="ppc_darkgreen darken-1"
            text
            @click="deleteItemConfirm"
          >
            OK
          </v-btn>
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogSelectOrganisations"
      :retain-focus="false"
      max-width="320px"
    >
      <v-card>
        <v-card-title class="d-flex flex-row flex-wrap py-0">
          <span>Select Organisation</span>
        </v-card-title>
        <v-divider />
        <v-card-text class="pa-0">
          <v-list rounded>
            <v-list-item-group color="primary">
              <v-list-item
                v-for="org in activeOrganisations"
                :key="org.id"
                @click="addOrganisation(org)"
              >
                <v-list-item-content>
                  <v-list-item-title>
                    {{ org.name }}
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    {{ nationalityById.get(org.country_id) || '—' }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="ppc_darkgreen darken-1"
            text
            @click="dialogSelectOrganisations = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>

import inputRules from '../mixins/inputRules';
import formattedDate from '../mixins/formattedDate';
import dayjs from 'dayjs';

export default {

    mixins: [inputRules, formattedDate],
    data: () => ({
        dialogEditContact: false,
        dialogDelete: false,
        dialogSelectOrganisations: false,
        headersContacts: [
            {
            text: 'Name',
            align: 'start',
            value: 'name',
            width: '25ch',
            },
            { text: 'Surname', value: 'surname', width: '35ch' },
            { text: 'Organisation(s)', value: 'organisations', width: '400px' },
            { text: 'Role', value: 'role' },
            { text: 'Comments', value: 'comments' },
            { text: 'Obs', value: 'obsolete'},
            { text: 'Actions', value: 'actions', sortable: false, width: '200px' },
        ],
        headersConnectedOrganisations: [
            { text: 'Organisation', value: 'name' },
            { text: 'Country', value: 'country_id' },
            { text: 'Actions', value: 'actions', sortable: false, width: '200px' },
        ],
        isNew: true,
        editedItem: {
            name: '',
        },
        defaultItem: {
            name: '',
        },
        dialogContactInfo: false,
        contact: false,
        searchContacts: '',
        pendingOrganisationIds: [],
    }),

    computed: {
        contactsWithMeta() {
            return this.$store.state.contacts.map(contact => ({
                ...contact,
                organisations: this.$store.getters.organisationNamesByContact(contact.id),
                role: this.buildRole(contact),
            }));
        },

        formTitle () {
            return this.isNew ? 'New Contact' : 'Edit Contact';
        },

        connectedOrganisations() {
            return this.$store.state.organisations
            .filter(org => this.pendingOrganisationIds.includes(org.id));
        },

        activeOrganisations() {
            return this.$store.state.organisations.filter(org => org.obsolete === null);
        },

        nationalityById() {
            return new Map(
                this.$store.state.itemsNationality.map(c => [c.id, c.nationality])
            );
        },
        
    },

    watch: {
    },

    beforeCreate () {
        this.$store.dispatch('setLoadingApp', 1)
    },

    created () {
        dayjs.locale("en");
        this.initialize()
    },

    methods: {
      async initialize () {
        this.getData();
      },

    async getData() {
        this.$store.dispatch('setLoadingApp', 1);

        await Promise.all([
            this.$store.dispatch('getContacts'),
            this.$store.dispatch('getOrganisations'),
            this.$store.dispatch('getOrganisationContacts'),
        ]);

        this.$store.dispatch('setLoadingApp', 0);
    },
    
    buildRole(contact) {
        const roles = [
            contact.staff && 'staff',
            contact.agency && 'agency',
            contact.teaching && 'teaching',
            contact.accommodation && 'accommodation',
            contact.projects && 'projects',
            contact.tours && 'tours',
            contact.payer && 'payer',
            contact.receiver && 'receiver',
        ];

        return roles.filter(Boolean).join(', ');
    },

    newContact() {
        this.isNew = true;
        this.editedItem = { country_id: 184, obsolete: null };
        this.dialogEditContact = true;
    },

    editItem(item) {
        this.isNew = false;
        this.editedItem = { ...item };

        // initialize pending orgs from current connections
        this.pendingOrganisationIds =
            this.$store.state.organisationsContacts
            .filter(oc => oc.contact_id === item.id)
            .map(oc => oc.organisation_id);

        this.dialogEditContact = true;
    },

    addOrganisation(org) {
        if (!this.pendingOrganisationIds.includes(org.id)) {
            this.pendingOrganisationIds.push(org.id);
        }

        this.dialogSelectOrganisations = false;
    },

    deleteConnectedOrganisation(org) {
        this.pendingOrganisationIds =
            this.pendingOrganisationIds.filter(id => id !== org.id);
    },

      deleteItem(item) {
        // work with domain identity, not array index
        this.isNew = false;
        this.editedItem = { ...item };

        const isInUse = [
            'teaching',
            'accommodation',
            'agency',
            'payer',
            'receiver',
            'staff',
        ].some(key => Number(this.editedItem[key]) > 0);

        if (isInUse) {
          this.$store.dispatch('errorMessage', 'Contact is still in use');
          return;
        }

        this.dialogDelete = true;
      },

      async deleteItemConfirm () {
        const response = await this.$store.dispatch('deleteContact', this.editedItem.id);

        if (response?.data?.affectedRows === 1) {
          this.$store.dispatch('successMessage', 'Contact deleted');
          await this.$store.dispatch('getContacts');
        } else {
          this.$store.dispatch('errorMessage', 'Something went wrong');
        }

        this.closeDelete();
      },

      closeDialogEditContact () {
        this.dialogEditContact = false;

        // reset edited item
        this.editedItem = { ...this.defaultItem };

        // clear temporary organisation links (editing buffer)
        this.pendingOrganisationIds = [];

        // reset form validation state if form exists
        if (this.$refs.dialogForm) {
          this.$refs.dialogForm.resetValidation();
        }

        // reset mode
        this.isNew = true;
      },

      closeDelete () {
        this.dialogDelete = false
        this.editedItem = Object.assign({}, this.defaultItem)
      },

      setObsolete(event) {
            if (event) {
                this.editedItem.obsolete = dayjs().format("YYYY-MM-DD")
            } else {
                this.editedItem.obsolete = null
            }
        },

    async saveContact () {
        if (!this.$refs.dialogForm.validate()) return;

        const { name, surname, id } = this.editedItem;

        const normalizedName = (name || '').trim().toLowerCase();
        const normalizedSurname = (surname || '').trim().toLowerCase();

        const duplicate = this.$store.state.contacts.some(contact =>
            (contact.name || '').trim().toLowerCase() === normalizedName &&
            (contact.surname || '').trim().toLowerCase() === normalizedSurname &&
            contact.id !== id
        );

        if (duplicate) {
            this.$store.dispatch(
                'errorMessage',
                `The name "${name} ${surname}" is already in use!`
            );
            return;
        }

        // 1️⃣ Insert / Update contact
        const response = await this.$store.dispatch('insertContact', this.editedItem);

        // if it was a new contact, make sure we have the generated id
        if (!this.editedItem.id && response?.insertId) {
            this.editedItem.id = response.insertId;
        }

        const contactId = this.editedItem.id;

        // 2️⃣ Sync organisation links
        // remove existing links first (safe & simple approach)
        await this.$store.dispatch('deleteOrganisationContactsByContact', contactId);

        // insert selected links
        for (const orgId of this.pendingOrganisationIds) {
            await this.$store.dispatch('insertOrganisationContact', {
                contact_id: contactId,
                organisation_id: orgId,
            });
        }

        // 3️⃣ Refresh store data
        await this.getData();

        // 4️⃣ Close dialog cleanly
        this.closeDialogEditContact();
    },

        // openOrganisations(item) {
        //     this.$store.dispatch('setLoadingApp', 1)
        //     this.$router.push({ name: 'Organisations', params: { contactId: item.id } })
        // },
    },
  }

</script>

<style>
    .v-card__title {
        color: #35b729;
        word-break: normal !important;
    }
    .v-card__subtitle { padding-top: 0; padding-bottom: 0;}
    .pos_absolute {
        position: absolute;
    }
</style>